import React from 'react'

// import Home from '../views/pages/home/Index'
// import Note from '../views/pages/note/Index'
// import Book from '../views/pages/book/Index'
// import Task from '../views/pages/task/Index'
// import Order from '../views/pages/order/Index'

import AdminEdit from '@/pages/admin/edit'
import AdminHome from '@/pages/admin/home'
import Note from '@/pages/admin/note'
import Book from '@/pages/admin/book'

import {
  DesktopOutlined,
  UserOutlined,
  DownOutlined,
  BookOutlined,
  MoneyCollectOutlined,
  ClockCircleOutlined,
  FormOutlined
} from '@ant-design/icons'

export default [
  {
    name: '面板',
    path: '/admin/home',
    icon: <DesktopOutlined />,
    component: AdminHome,
    show: true
  },
  {
    name: '编辑',
    path: '/admin/edit/:articleId',
    icon: <DesktopOutlined />,
    component: AdminEdit
  },
  {
    name: '新增',
    path: '/admin/edit',
    icon: <DesktopOutlined />,
    component: AdminEdit,
    show: true
  },
  {
    name: '笔记',
    path: '/admin/note',
    icon: <FormOutlined />,
    component: Note,
    show: true
  },
  {
    name: '书签',
    path: '/admin/book',
    icon: <BookOutlined />,
    component: Book,
    show: true
  },
  // {
  //   name: '面板',
  //   path: '/',
  //   icon: <DesktopOutlined />,
  //   component: Home
  // },
  // {
  //   name: '任务',
  //   path: '/task',
  //   icon: <ClockCircleOutlined />,
  //   component: Task
  // },
  // {
  //   name: '订单',
  //   path: '/order',
  //   icon: <MoneyCollectOutlined />,
  //   component: Order
  // }
]
